import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { ListViewImplementation } from "@commoncore/implementation/ListViewImplementation";
import { CustomMetadataService } from "@commoncore/services/custom-metadata.service";
import { CustomSortService } from "@commoncore/services/custom-sort.service";
import { JustifiedView } from "@commoncore/utils/JustifiedViewUtil";
import { MultiSelectLibrary } from "@commoncore/utils/MultiSelectUtil";
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { Subscription } from 'rxjs';
import { IndexedDBModule } from '../database/IndexedDBManager';

export class AlbumsImplementation {

    public router: any;
    public http: any;
    public route:any;
    public universalService:any;
    public globalService:any;
    public customMetadata:any;
    public JsView:any;
    public customSort:any;
    public multiSelect:any;
    public listService:any;
    public contextMenuService: any;
    listImpl:any;
    localStorageSvc:any;
    // loggerService: any;
    static singleInstance = null;
    albumsList:any = [];
    // albumObjectsList:any= [];
    albumsMetaData:any = [];
    // photosData = [];
    // audiosData = [];
    // videosData = [];
    // docsData = [];
    // allfilesData = [];
    // loadView:boolean = false;
    emptyTab:boolean = false;
    // isPublicAlbumConsent:'Y'|'N';
    // recentsArray:any = [];
    db: IndexedDBModule;
    albumsDataArray : any= [];
    // isAlbumDataInDB:boolean = false;
    isMyAlbumDataInDB:boolean = false;
    isSharedAlbumDataInDB:boolean = false;
    myAlbumStoreName = "MyAlbumsList";
    sharedAlbumStoreName = "SharedAlbumsList";
    albumsDataInDB:any = "";
    controller: any;
    isFirstUpload: boolean = false;
    containerHeightCalc:any;
    recalculateHeightService:any;
    subscription:Subscription;
    lazyLoadImgService:any;
    albumDetails: any;


    constructor(globalService) {
      this.globalService=globalService;
    }

    public static getInstance(globalService):AlbumsImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new AlbumsImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

    public setHandler(globalService){
      this.universalService = globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();
      this.route = globalService.getActivatedRoute();
      this.listService = globalService.getListServiceRef();
      this.listImpl = ListViewImplementation.getInstance(globalService)
      this.JsView = new JustifiedView(this.universalService);
      this.customMetadata = new CustomMetadataService(this.universalService,this.listService )
      this.customSort = new CustomSortService(this.universalService);
      this.contextMenuService = globalService.getContextMenuServiceRef();
      this.multiSelect = MultiSelectLibrary.getInstance(globalService);
      // this.loggerService = globalService.getLoggerServiceRef();
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
      this.db = IndexedDBModule.getInstance(globalService);
      this.recalculateHeightService = this.containerHeightCalc;
      this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();

      if(this.universalService.virtualGridEnabled){
        this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
      }
      var self = this;
      this.subscription = this.recalculateHeightService.onRecalculate().subscribe(response=>{
        if(response["reCalculateHeight"] == true && this.universalService?.selectedTab == "Album Details"){
          self?.setHeightForAlbumContents();
        }
      })
    }

    getAlbumDetails(url){
      var self = this;
      this.albumsMetaData = [];
      var currentUrl = window.location.href;
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
              suc=>{
                self.universalService.currentAlbum = suc["board"];
                if(self.universalService.currentAlbum["isShareAlbum"] && !currentUrl.includes('/albums/sharedalbums')){
                  var url = '/albums/sharedalbums/' + self.universalService.currentAlbum["boardKey"];
                  setTimeout(() => {
                    window.history.replaceState({}, '',url);
                  });
                }else if(!self.universalService.currentAlbum["isShareAlbum"] && !currentUrl.includes('/albums/myalbums')){
                  var url = '/albums/myalbums/' + self.universalService.currentAlbum["boardKey"];
                  setTimeout(() => {
                    window.history.replaceState({}, '',url);
                  });
                }
                
                self.universalService.currentAlbum["boardDescription"] = self.universalService.currentAlbum["boardDescription"] ? self.universalService.currentAlbum["boardDescription"] : "";
                var album = self.setCoverPicAndDescription(suc["board"]);
                self.universalService.currentAlbum = album[0];
                self.albumDetails = suc;
                resolve(suc)
              },
              err=>{
                  console.log("error in metadata of single album",err);
                  if(err["error"]["code"] == "BRSOM0402"){
                    self.universalService.showToast(err["error"]["error"],"error");
                    if(currentUrl.includes('myalbums')){
                      self.router.navigate(['/albums/myalbums'])
                    }else{
                      self.router.navigate(['/albums/sharedalbums'])
                    }
                    
                  }
                  reject(err)
              }
          )
      })
    }

    getAlbumsList(url){
      var self = this;
      this.albumsDataArray = [];
      self.universalService.showLoader = true;
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
            suc=>{
              //Store response in indexed DB
              if((self.isMyAlbumDataInDB == false || self.isSharedAlbumDataInDB == false) && suc.boards) {
                suc.boards.forEach(function (album, i) {
                  self.albumsDataArray[i]=album;
                });
                //Disabled cache for Album - cause of issue when users joins/leaves boards, updated data was not available 
                /*if(url.includes('albumType=s')) {
                  self.db.bulkAdd(self.sharedAlbumStoreName,self.albumsDataArray);
                  self.isSharedAlbumDataInDB = true;
                } else if(url.includes('albumType=p')) {
                  self.db.bulkAdd(self.myAlbumStoreName,self.albumsDataArray);
                  self.isMyAlbumDataInDB = true;
                }*/
                //self.db.saveBoardsListInDB(self.boardsDataArray);
              }
              self.setAlbumList(suc["boards"]?suc["boards"]:[]);
              resolve(self.albumsList);
            },
            error=>{
              reject(error)
              console.log("error in albums list api",error);
            },
          )
      })
    }
    
    setAlbumList(albums){
      this.albumsList = this.customMetadata.segregateData(albums,'albums');
      this.albumsList = this.sortAlbumsList(this.albumsList);
      this.albumsList = this.setCoverPicAndDescription(this.albumsList);
    }

    sortAlbumsList(arr){
        let albumsList = this.customSort.sortListViewFilesByAttribute(arr, 'Descending', 'lastModifiedDate');
        return albumsList;
    }

   
    setCoverPicAndDescription(albumList){
      var self = this;
      var albums = [];
      if (Array.isArray(albumList)) {
        albums = albumList;
      } else {
        albums.push(albumList)
      }
      albums.map(album => {
        if(album.boardCoverPic){
          let operator=album.boardCoverPic.includes("?") ? "&" : "?";
          let type = self.universalService.checkIfImgTypeParamIsRequired(album["coverPicMimeSubType"]);
          album.boardCoverPic = album.boardCoverPic+operator + "devicetype=web&size=d" + type;
        }

        if(album["boardMembers"]){
          let type = self.universalService.checkIfImgTypeParamIsRequired("");
          album["boardMembers"].map(member=>{
            if(member["profilePic"]) {
              let profilePicUrl = member["profilePic"].includes('?') ? member["profilePic"] + '&': member["profilePic"] + '?';
              member["profilePic"] = profilePicUrl + 'size=a&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
            }
          })
        }
      })
      return albums
    }

    async fetchSingleAlbumObjectList(suc,executedTask){
        var self = this;
        var albumsMetaData = [];
        this.universalService.mobileSelectedObj = [];
        suc = suc["files"]?suc["files"]:suc
        suc = this.setOwnerDetails(suc);
        if(suc.length == 0){
          this.emptyTab = true;
          return;
        }else{
          this.emptyTab = false;
        }
        if(executedTask != 'FTR')
        this.albumsMetaData = this.customSort.sortListViewFilesByAttribute(suc, 'Descending', 'lastModifiedDate')
        if(executedTask == 'FTR'){
          this.albumsMetaData = suc;
        }
        albumsMetaData = this.customMetadata.segregateData(this.albumsMetaData,'allfiles');
        // albumsMetaData = this.albumsMetaData["allfiles"];
        this.checkIfJustifiedLayout();
        if(self.universalService.showJustifiedLayout){
          if(albumsMetaData.length == 0) {
            self.albumsMetaData = albumsMetaData;
            self.emptyTab = true;
          } else {
            var justfiedViewFormat = await self.generateJustifiedView("#allFilesWrapperId",albumsMetaData);
            // this.albumsMetaData = [{
            //   "objects":justfiedViewFormat
            // }]
            self.albumsMetaData = justfiedViewFormat;
          }
        }else{
          var checkIfLastViewIsJustfied = albumsMetaData.find(obj=> (obj["imageTranscodeUrl"] != undefined && obj["imageTranscodeUrl"].includes("size=v")));
          if(checkIfLastViewIsJustfied){ // this check is added when album is in justified view, and user upload a file type that is not supported for justfied view, eg: videos, then we need to set the size of the image to d as per grid view
            albumsMetaData.map(obj=>{
              obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"].replace("size=v","size=c");
            })
          }
          this.albumsMetaData = albumsMetaData;
        }
        // this.albumsMetaData.map(obj=>{
        //   obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"].replace("size=v","size=c");
        // })
        // this.allfilesData = this.albumsMetaData["allfiles"]
        // this.photosData = this.albumsMetaData["photos"]
        // this.audiosData = this.albumsMetaData["audios"]
        // this.videosData = this.albumsMetaData["videos"]
        // this.docsData = this.albumsMetaData["docs"]
        // this.setObjectPreviewArray();
        // this.universalService.objectsPreviewArray = this.albumsMetaData[0]["objects"] ? this.albumsMetaData[0]["objects"] : this.albumsMetaData;
        // setTimeout(() => {
          AppEvents.virtualDOMObservable.next({"updateVDOM":true,"forceRefresh":true})
        // }, 200);
        AppEvents.multiSelectEvent.next({"dataArray":suc});
        this.bindMultiSelect("#allFilesWrapperId")
        setTimeout(() => {
          this.setHeightForAlbumContents();
        }, 600);
    }

    checkIfJustifiedLayout(){
      if(this.universalService.currentAlbum["imageCount"] > 0 && this.universalService.currentAlbum["audioCount"] == 0 && this.universalService.currentAlbum["videoCount"] == 0 && this.universalService.currentAlbum["othersCount"] == 0){
        this.universalService.showJustifiedLayout = true
      }else{
        this.universalService.showJustifiedLayout = false;
      }
    }

    async refreshAlbumsDataOnUpload(obj){
      if(obj.mimeType == 'image') {
        this.universalService.currentAlbum.imageCount += 1;
      } else if(obj.mimeType == 'video') {
        this.universalService.currentAlbum.videoCount += 1;
      } else if(obj.mimeType == 'audio') {
        this.universalService.currentAlbum.audioCount += 1;
      } else {
        this.universalService.currentAlbum.othersCount += 1;
      }
      let allAlbumObjects = this.albumsMetaData
      if(allAlbumObjects[0] != undefined && allAlbumObjects[0]['objects'] && allAlbumObjects[0]['objects'].length > 0) {
        allAlbumObjects[0]['objects'].unshift(obj);
      } else {
        allAlbumObjects.unshift(obj);
      }
      
      if(this.emptyTab == true){
        this.emptyTab = false;
        setTimeout(() => {
          this.checkIfJustifiedLayout();
          this.setHeightForAlbumContents();
          this.bindMultiSelect("#allFilesWrapperId")
        }, 10);
      }
      //Update files data in indexedDB for album
      if(this.universalService.currentAlbum) {
        this.universalService.currentAlbum.filesCount = allAlbumObjects.length;
        this.universalService.currentAlbum.lastModifiedDate = new Date().getTime();
        // if(allAlbumObjects[0].displayName.toLowerCase() == 'image') {
        //   this.universalService.currentAlbum.imageCount++;
        // }

        //Disabled cache for Album - cause of issue when users joins/leaves boards, updated data was not available 
        /*
        if(this.universalService.currentAlbum.isShareAlbum == true)
          this.updateAlbumDataInDB(this.sharedAlbumStoreName, this.universalService.currentAlbum);
        else 
          this.updateAlbumDataInDB(this.myAlbumStoreName, this.universalService.currentAlbum);
        */

        if(this.universalService.currentAlbum.imageCount == 1) {
          this.isFirstUpload = true;
          this.setCoverPic(ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumDetails"] + "/" + this.universalService.currentAlbum["boardKey"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["coverPic"], allAlbumObjects[0]);
        }
      }
      this.fetchSingleAlbumObjectList(allAlbumObjects,"");
      
      // this.setAlbumFilterHeight();
      // if(this.universalService.showJustifiedLayout){
        // AppEvents.emit(EventsList.UPDATE_DATA);
          // this.allfilesData = await this.generateJustifiedView("#allFilesWrapperId",this.allfilesData);
          // var allData = [{
          //   "objects":this.allfilesData
          // }]
          // this.allfilesData = allData;
      // }

      //update used space post upload
      if(obj.usedSpace || obj.usedSpace == 0) {
        let userData = this.localStorageSvc.getUserData(true);
        obj["usedSpace"] =  obj["usedSpace"] == 0 ? 0 : ( obj["usedSpace"] ?  obj["usedSpace"] : userData["quota"]["totalUsedQuota"]);
        userData["quota"]["totalUsedQuota"] =  obj["usedSpace"];
        AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
      }
    }

    resetValues(){
        this.albumsList = [];
        // this.albumObjectsList = [];
        // this.allfilesData = [];
        // this.photosData = [];
        // this.audiosData = [];
        // this.videosData = [];
        // this.docsData = [];
    }

    setHeightForAlbumContents(){
      var self = this;
      self.setHeightForContainer();
      $(window).resize(function () {
        self.setHeightForContainer();
      });
    }

    setHeightForContainer(){
      var self = this;
      if(this.universalService.virtualGridEnabled) return
      // if(!this.universalService.isMobileDevice && this.universalService.selectedTab == 'Album Details'){
      //   if(this.universalService.currentTab == 'audio' || this.universalService.currentTab == 'docs' ){
      //     this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-banner-container'],30);
      //     return
      //   }
      // }
      var height = 0;
      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      var mainWrapperClass = this.universalService.showJustifiedLayout ? ".allfiles-justified-wrapper" : ".scrollableContainer"
      if(this.universalService.selectedTab == 'Albums'){
        height = $('.heading-wrap').outerHeight(true);
      }else if(this.universalService.selectedTab == 'Album Details'){
        height = $('.albums-header-main').outerHeight(true);
      }
      if($('.email-verification-banner').outerHeight(true)){
        height = height + $('.email-verification-banner').outerHeight(true);
      }
      setTimeout(() => {
        self.containerHeightCalc.calculateHeight(mainWrapperClass,['.pseudo-header','.pseudo-top-header','.pseudo-banner-container','.pseudo-mobile-header'],this.universalService.isMobileDevice ? (20 + collapsedHeight) : 69);
      }, 500);
    }

    bindMultiSelect(element){
      setTimeout(() => { // this is added because the element is not being renedered on the DOM in some scenarios
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        this.multiSelect.bindMultiSelectLibrary(element, "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
      }, 100);
    }

    generateJustifiedView(id,objects){
      var data = [];
      if(objects[0]["objects"]){
        data  = objects
      }else{
        data  = [{
          "objects":objects
        }]
      }
      var justifiedView = this.JsView.generateJustifiedView(data, id, this.universalService.rowHeightTolerance);
      return justifiedView[0]["objects"];
    }

    selectAll(event){
      this.listImpl.selectAll(event)
    }
    // decideRandomColor(albumName){
    //   if(this.universalService.currentAlbum != undefined){
    //     albumName = this.universalService.currentAlbum["albumName"];
    //   }
    //   var colors = [
    //     "#1abc9c",
    //     "#2ecc71",
    //     "#3498db",
    //     "#9b59b6",
    //     "#34495e",
    //     "#d35400",
    //     "#e74c3c",
    //     "#009432",
    //     "#0652DD",
    //     "#7A3464",
    //     "#ED4C67",
    //     "#6F1E51",
    //     "#1B1464",
    //     "#006266",
    //     "#17c0eb",
    //     "#1B9CFC",
    //     "#3B3B98",
    //     "#B33771",
    //     "#6D214F",
    //     "#1e3799",
    //   ];
    //   var hash = 0;
    //   if (albumName.boardName) {
    //     for (var i = 0; i < albumName.boardName.length; i++) {
    //       hash = albumName.boardName.charCodeAt(i) + ((hash << 5) - hash);
    //     }
    //   } else { 
    //     for (var i = 0; i < boardName.length; i++) {
    //       hash = albumName.charCodeAt(i) + ((hash << 5) - hash);
    //     }
    //   }
    //   var index = Math.abs(hash % (colors.length - 1));
    //   return colors[index];
    // }
    
    // async pickRandomColor(event,albumName) {
    //   let color = await this.decideRandomColor(albumName)
    //   let target = event.target;
    //   let target_parent = target.parentNode;
    //   target_parent.style.backgroundColor = color;
    //   target.style.display = 'none';
    // }

    async pickRandomColorForAlbumInfo(event,albumName) {
      // let color = await this.decideRandomColor(albumName)
      // let target = document.querySelectorAll('.albumInfoColorCont')as any;
      // Array.prototype.forEach.call(target, function (obj) {
      //   obj.style.backgroundColor = color;
      // });
    }

    // infoThumbanailError(event){
    //   let target = event.target;
    //   target.style.display = 'none';
    // }

    setCoverPic(url,selectedObject){
      var self = this;
      var payload = {
        "boardCoverPicObjectKey":selectedObject["objectKey"]
      }
      return new Promise(function(resolve,reject){
        self.http.put(url,payload).subscribe(
          suc=>{
            self.setCoverPicOnTheAlbum(suc,selectedObject);
          },
          err=>{
            console.log("cover pic set error",err);
            self.universalService.showLoader = false;
          }
        )
      })
    }


    setCoverPicOnTheAlbum(coverPicResponse,selectedObject){
      if(coverPicResponse["boardCoverPicObjectKey"] == selectedObject["objectKey"]){
        if(!this.isFirstUpload) {
          this.universalService.showToast(TOAST["ALBUM_COVER_PIC_SET_SUCCESSFULLY"],"success");
        }
        this.isFirstUpload = false;
        this.universalService.showLoader = false;
        this.universalService.currentAlbum["boardCoverPic"] = coverPicResponse["boardCoverPic"];
        var album = this.setCoverPicAndDescription(coverPicResponse);
        this.universalService.currentAlbum = album[0];
        this.listService.deSelectAll();

        //Update album cover pic in indexedDB
        if(this.universalService.currentAlbum) {
          this.universalService.currentAlbum.boardCoverPic = coverPicResponse.boardCoverPic;
          this.universalService.currentAlbum.boardCoverPicObjectKey = coverPicResponse.boardCoverPicObjectKey;
          this.universalService.currentAlbum.lastModifiedDate = new Date().getTime();
          //Disabled cache for Album - cause of issue when users joins/leaves boards, updated data was not available 
          /*
          if(this.universalService.currentAlbum.isShareAlbum == true)
            this.updateAlbumDataInDB(this.sharedAlbumStoreName, this.universalService.currentAlbum);
          else 
            this.updateAlbumDataInDB(this.myAlbumStoreName, this.universalService.currentAlbum);
          */
        }
      }
    }

    onScrollDown(){
      let self = this;
      if(!this.universalService.virtualGridEnabled){
        self.lazyLoadImgService.isScrollingStopped();
      }
      var toppos;
      if(self.universalService.currentAlbum != undefined) {
        toppos = $(".scrollableContainer").scrollTop();
      }else { // if the user is on album list page
        toppos = $(".scrollableContainer").scrollTop();
      }
      if (toppos == 0) {
        self.universalService.scrollToTopIcon = false;
      } else {
        self.universalService.scrollToTopIcon = true;
      }
    }

    listScrollDown(){ //ag grid scrolldown
      if (this.listService.listOptions.api.getVerticalPixelRange().top == 0)
        this.universalService.scrollToTopIcon = false;
      else
      this.universalService.scrollToTopIcon = true; 
    }

    setOwnerDetails(files){
      let self = this
      const userData = self.localStorageSvc.getUserData(true);
      //let userID = self.localStorageSvc.getUserId(true);
      let userID = userData["userId"];
      files.map(function(object){
        if(object["owner"]){
          if(object["owner"]["ownerUserId"] == userID){
            object["isLoggedInUsrFileOwner"] = true
          }else{
            object["isLoggedInUsrFileOwner"] = false
          }
          if(userID == self.universalService.currentAlbum.owner.ownerUserId){
            object["isLoggedInUsrAlbumOwner"] = true
          }else{
            object["isLoggedInUsrAlbumOwner"] = false
          }
        }
      })
      return files;
    }

    deletedList(list){
      list.map(obj=>{
        var index = this.albumsMetaData.indexOf(obj);
        if(index >= 0){
          this.albumsMetaData.splice(index,1)
        }
        if(obj.mimeType == 'image') {
          this.universalService.currentAlbum.imageCount -= 1;
        } else if(obj.mimeType == 'video') {
          this.universalService.currentAlbum.videoCount -= 1;
        }  else if(obj.mimeType == 'audio') {
          this.universalService.currentAlbum.audioCount -= 1;
        } else {
          this.universalService.currentAlbum.othersCount -= 1;
        }
      })
      
      return this.albumsMetaData;
    }

    updateAlbumCoverPic(url,objectKey){
      var self = this;
      var params = {
          boardCoverPicObjectKey: objectKey
        }
      return new Promise(function(resolve,reject){
          self.http.put(url,params).subscribe(
              suc=>{
                  self.universalService.currentAlbum.boardCoverPicObjectKey = suc["boardCoverPicObjectKey"];
                  resolve(suc)
              },err=>{
                  console.log("error in delete album",err);
                  reject(err);
              }
          )
      })
  }

  updateAlbumDataInDB(dbStore, albumObj) {
    if(this.isMyAlbumDataInDB || this.isSharedAlbumDataInDB) {
      return this.db.update(dbStore, albumObj).then((result) => {
        
      });
    }
  }

  deleteAlbumDataInDB(albumKey, isShared) {
    if(isShared) {
      this.db.deleteByKey(this.sharedAlbumStoreName, albumKey);
    } else {
      this.db.deleteByKey(this.myAlbumStoreName, albumKey);  
    }
  }
}